<template>
    <div id="leading-enterprises">
        <div class="index_left_centerpage" v-loading="pageLoading">
            <div class="whitebox ">
                <div class="enterparise_guide">
                    <div class="w95mg">
                        <div class="s_screen_choose">
                            <span class="span-screen">{{ notionname }}</span>
                        </div>
                    </div>
                </div>
                
                <div class="enterprise_list_box" v-show="enterpristlist.length != 0">
                    <div class="table-section">
                        <div class="table-header">
                            <div class="table-title">
                                <i class="el-icon-document-checked"></i>
                                <span>企业</span>
                                <el-tag size="small" type="info">{{ total }} 条</el-tag>
                            </div>
                        </div>
                    </div>
                    <!-- 龙头企业 -->
                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table"
                        v-if="pagetype == 0 || pagetype == 1 || pagetype == 3 || pagetype == 9">
                        <tr>
                            <th>企业名称</th>
                            <th>所属产业</th>
                            <th>画像标签</th>
                            <th>地区</th>
                            <th>投资数</th>
                            <th>员工人数</th>
                        </tr>
                        <tr :key="i" v-for="(list, i) in enterpristlist">
                            <td class="title" @click="detailrouterto('/enterprises', list.stockCode, pagetype)">
                                {{ list.title }}</td>
                            <td class="conpanytags hastag">
                                <span class="span-tag" :key="index" v-for="(item, index) in list.notionlist"
                                    @click="tagrouter('/enterpriseTag', pagetype, 'notion', item.id, item.name)">{{ item.name }}</span>
                            </td>
                            <td class="conpanytags hastag">
                                <span class="span-tag" :key="index" v-for="(item, index) in list.taglist"
                                    @click="tagrouter('/enterpriseTag', pagetype, 'tag', item.id, item.name)">{{ item.name }}</span>
                            </td>
                            <td>{{ list.area }}</td>
                            <td v-html="list.invest == 50 ? '50+' : list.invest"></td>
                            <td>{{ list.insurePerson }}</td>
                        </tr>
                    </table>
                    <!-- 创新企业 -->
                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="pagetype == 2">
                        <tr>
                            <th>企业名称</th>
                            <th>所属产业</th>
                            <th>画像标签</th>
                            <!-- <th>星级</th> -->
                            <th>融资轮次</th>
                            <th>融资时间</th>
                            <th>融资金额</th>
                            <th>地区</th>
                            <th>投资方</th>
                        </tr>
                        <tr :key="i" v-for="(list, i) in enterpristlist">
                            <td class="title" @click="detailrouterto('enterprises', list.stockCode, pagetype)">
                                {{ list.title }}</td>
                            <td class="conpanytags hastag1" v-show="list.notion != ''">
                                <span class="span-tag" :key="index" v-for="(item, index) in list.notionlist"
                                    @click="tagrouter('/enterpriseTag', pagetype, 'notion', item.id, item.name, 'quality2')">{{ item.name }}</span>
                            </td>
                            <td class="conpanytags" v-show="list.notion == ''" style="width: 100px;">
                                <div class="" style="color: #999;">-</div>
                            </td>
                            <td class="conpanytags hastag1" v-show="list.tag != ''">
                                <span class="span-tag" :key="index" v-for="(item, index) in list.taglist"
                                    @click="tagrouter('/enterpriseTag', pagetype, 'tag', item.id, item.name, 'quality2')">{{ item.name }}</span>
                            </td>
                            <td class="conpanytags" v-show="list.tag == ''" style="width: 100px;">
                                <div class="" style="color: #999;">-</div>
                            </td>
                            <td v-html="list.financingRound.length > 0 ? list.financingRound[0].rount : '-'"></td>
                            <td v-html="list.financingRound.length > 0 ? list.financingRound[0].time : '-'"></td>
                            <td v-html="list.financingRound.length > 0 ? list.financingRound[0].amount : '-'"></td>
                            <td>{{ list.area }}</td>
                            <td class="orglist">
                                <p v-if="list.financingRound.length > 0"><span :key="inds"
                                        v-for="(org, inds) in list.financingRound[0].orgList" data="org.id"
                                        :class="org.id != 0 ? 'curp' : ''"
                                        @click="routerlinkid('/investement-enterprises', org.id)">
                                        {{ org.orgName }}<i
                                            v-if="inds != list.financingRound[0].orgList.length - 1">、</i></span></p>
                                <p v-if="list.financingRound.length == 0">-</p>
                            </td>
                        </tr>
                    </table>
                    <!--投资机构所投资的该领域企业  -->
                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table"
                        v-if="pagetype == 8 && enterprise_id">
                        <tr>
                            <th>排名</th>
                            <th>企业名称</th>
                            <th>所属产业</th>
                            <th>画像标签</th>
                            <th>融资轮次</th>
                            <th>融资时间</th>
                            <th>融资金额</th>
                            <th>地区</th>
                            <th>投资方</th>
                        </tr>
                        <tr :key="i" v-for="(list, i) in enterpristlist">
                            <td>{{ i + 1 }}</td>
                            <td class="title" @click="detailrouterto('enterprises', list.stockCode, pagetype)">
                                {{ list.title }}</td>
                            <td class="conpanytags hastag1" v-show="list.notion != ''">
                                <span class="span-tag" :key="index" v-for="(item, index) in list.notionlist"
                                    @click="tagrouter('/enterpriseTag', pagetype, 'notion', item.id, item.name, 'quality2')">{{ item.name }}</span>
                            </td>
                            <td class="conpanytags" v-show="list.notion == ''" style="width: 100px;">
                                <div class="" style="color: #999;">-</div>
                            </td>
                            <td class="conpanytags hastag1" v-show="list.tag != ''">
                                <span class="span-tag" :key="index" v-for="(item, index) in list.taglist"
                                    @click="tagrouter('/enterpriseTag', pagetype, 'tag', item.id, item.name, 'quality2')">{{ item.name }}</span>
                            </td>
                            <td class="conpanytags" v-show="list.tag == ''" style="width: 100px;">
                                <div class="" style="color: #999;">-</div>
                            </td>
                            <td>{{ list.rount }}</td>
                            <td>{{ list.time }}</td>
                            <td>{{ list.amount }}</td>
                            <td>{{ list.area }}</td>
                            <td class="orglist">
                                <p>
                                    <span :key="inds" v-for="(org, inds) in list.orgList" data="org.id"
                                        :class="org.id != 0 ? 'curp' : ''"
                                        @click="routerlinkid('/investement-enterprises', org.id)"><i
                                            v-if="inds > 0">、</i>{{ org.orgName }}</span>
                                </p>
                                <p v-if="list.orgList.length == 0">-</p>
                            </td>
                        </tr>
                    </table>
                    <!-- 研究机构 -->
                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="pagetype == 7">
                        <tr>
                            <th>企业名称 </th>
                            <th>地区</th>
                            <th>员工人数</th>
                            <th>研究领域</th>
                        </tr>
                        <tr :key="i" v-for="(list, i) in enterpristlist">
                            <td class="title" @click="detailrouterto('/resources-enterprises', list.id, list.title)">
                                {{ list.title }}</td>
                            <td>{{ list.area }}</td>
                            <td>{{ list.insurePerson }}</td>
                            <td :class="list.notion == '' ? 'conpanytags' : 'conpanytags hastag'">
                                <span class="span-tag" :key="index" v-for="(item, index) in list.notionlist"
                                    @click="tagrouter('/enterpriseTag', pagetype, 'notion', item.id, item.name)">{{ item.name }}</span>
                                <i v-show="list.notionlist.length == 0" style="color:#999">-</i>
                            </td>
                        </tr>
                    </table>
                    <!-- 投资机构公司列表 -->
                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="pagetype == 6">
                        <tr>
                            <th>企业名称 </th>
                            <th>投资领域</th>
                            <th>画像标签</th>
                            <th>项目数</th>
                            <th>进入下一轮项目数</th>
                            <!-- <th>投资阶段</th> -->
                            <th>机构类型</th>
                            <th>地区</th>
                            <th>管理规模 </th>
                        </tr>
                        <tr :key="i" v-for="(list, i) in enterpristlist">
                            <td class="title" @click="detailrouterto('/investement-enterprises', list.id, pagetype)">
                                {{ list.name }}</td>
                            <td class="conpanytags hastag">
                                <span class="span-tag" :key="index" v-for="(item, index) in list.notionlist"
                                    @click="tagrouter('/enterpriseTag', pagetype, 'notion', item.id, item.name)">{{ item.name }}</span>
                                <i v-if="list.notion == ''">-</i>
                            </td>
                            <td class="conpanytags hastag">
                                <span class="span-tag" :key="index" v-for="(item, index) in list.taglist"
                                    @click="tagrouter('/enterpriseTag', pagetype, 'tag', item.id, item.name)">{{ item.name }}</span>
                                <i v-if="list.tag == ''">-</i>
                            </td>
                            <td>{{ list.projectCount }}</td>
                            <td>{{ list.nextRound }}</td>
                            <!-- <td>{{list.stage}}</td> -->
                            <td>{{ list.type }}</td>
                            <td>{{ list.area }}</td>
                            <td>
                                <span v-if="list.asset != ''">{{ list.asset }}</span>
                                <span v-if="list.asset == ''">-</span>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="pagination-wrapper oh w95mg py-3">
                            <el-pagination class="fr" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                            :page-sizes="[20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"
                            background />
					</div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
    name: 'enterpriseTag',
    computed: {
        ...mapState({
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(['isCollapse'])
    },
    data() {
        return {
            pageLoading: false,
            enterprise_id: 0, //机构详情页跳转自带企业id
            msg: "标签筛选页",
            page: 1, //显示的是哪一页
            pagetype: 2,
            enterinarr: [{
                curindex: 1,
                type: 9,
                name: "上市公司",
            },
            {
                curindex: 2,
                type: 1,
                name: "龙头企业",
            },
            {
                curindex: 3,
                type: 2,
                name: "创新企业",
            },
            {
                curindex: 4,
                type: 3,
                name: "优质企业",
            },
            {
                curindex: 5,
                type: 0,
                name: "全部企业",
            },
            {
                curindex: 6,
                type: 6,
                name: "投资机构",
            },
            {
                curindex: 7,
                type: 7,
                name: "科研机构",
            },
            {
                curindex: 8,
                type: 8,
                name: "投资机构所投资的该领域企业",
            },
            ],
            haspage: true, //是否还有下一页
            pageSize: 10, //每一页显示的数据条数
            total: 0, //记录总数
            totalPage: 1,
            maxPage: 10, //最大页数  
            enterpristlist: [],
            num: 1,
            testtoken: "-d8d2de4bc22ab997e946f42f9d49b79b",
            notionname: "标签",
            typefont: '龙头企业',
            userdata: {},
        }
    },
    beforeCreate() {
        this.pageLoading = false;
    },
    created() {
        this.$nextTick(() => {
            // 禁用右键
            document.oncontextmenu = new Function("event.returnValue=false");
            // 禁用选择
            document.onselectstart = new Function("event.returnValue=false");
        });
        var that = this;
        this.userdata = this.getuseriformation();
        this.tagid = this.$route.query.id;
        this.pagetype = this.$route.query.type;
        this.key = this.$route.query.key;
        this.notionname = this.$route.query.keyword;
        this.enterprise_id = this.$route.query.eid;
        // if(this.pagetype == 1){this.typefont = '龙头企业'};
        // if(this.pagetype == 'all' || this.pagetype == 0){this.pagetype=0;this.typefont = '全部企业'};
        // if(this.pagetype == 2){this.typefont = '新兴企业'};
        // if(this.pagetype == 6){this.typefont = '研究院'}; //研究院就是创新资源
        // if(this.pagetype == 5){this.typefont = '投资机构'};  
        // if(this.pagetype == 4){this.typefont = '优质企业'};
        // if(this.pagetype == 9){this.typefont = '上市企业'};
        for (var i = 0; i < this.enterinarr.length; i++) {
            if (this.enterinarr[i].type == that.pagetype) {
                that.typefont = that.enterinarr[i].name;
                that.curindex = that.enterinarr[i].curindex;
            }
        }
    },
    mounted() {
        this.userdata = this.getuseriformation();
        var that = this;
        this.handleCurrentChange(1);
        if (this.key == 'tag') {
            document.title = this.notionname + '-' + '标签搜索';
        } else {
            document.title = this.notionname + '-' + '产业搜索';
        }

    },

    methods: {
        detailrouterto(path, id, type) {
            this.routerblank(path + '?type=' + type + '&id=' + id);
        },
        getEnterpriseList(pages) {
            this.pageLoading = true;
            var ajaxurl = "";
            var pagestype = this.pagetype;
            this.page = pages ? pages : 1;
            var tagjson = "&" + this.key + '=' + this.tagid;
            if (pagestype == 1 || pagestype == 2 || pagestype == 3 || pagestype == 9 || pagestype == 0) {
                ajaxurl = this.$api.cyl.enterprise.list() + '?type=' + pagestype + tagjson + '&page=' + this.page;
            } else if (this.pagetype == 6) {
                ajaxurl = this.$api.cyl.investorg.list() + "?province=0" + tagjson + '&page=' + pages;
            } else if (this.pagetype == 7) {
                ajaxurl = this.$api.cyl.academy.list() + "?province=0" + tagjson + '&page=' + pages;
            } else if (pagestype == 8) {
                ajaxurl = this.$api.cyl.investorg.enterpriseList() + '?id=' + this.enterprise_id + '&resultType=1&notionCode=' + this.tagid;
            }
            console.log(ajaxurl);
            var that = this;
            console.log(ajaxurl)
            this.$axios.get(ajaxurl, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {
                // console.log(res)  
                console.log(ajaxurl, res);
                if (res.success) {
                    that.enterpristlist = res.list;
                    for (var i = 0; i < res.list.length; i++) {
                        that.enterpristlist[i].notionlist = that.taglistfun(that.enterpristlist[i].notion,
                            that.enterpristlist[i].notionCode, 'notionsort');
                        that.enterpristlist[i].taglist = that.taglistfun(that.enterpristlist[i].tag, that.enterpristlist[i].tagCode);
                        //创新企业专属
                        if (that.pagestype == 2 && that.enterpristlist[i].financingRound == null) {
                            that.enterpristlist[i].financingRound = [];
                        }
                    }
                    that.pageLoading = false;;
                    that.totalPage = res.totalPage;
                    that.pageSize = res.pageSize;
                    that.total = pagestype == 8 ? res.list.length : res.totalRecord;
                    that.haspage = res.list.length == res.pageSize;
                } else {
                    that.pageLoading = false;

                }
            })
        },
        // 分页
        handleSizeChange(val) {
            this.pageSize = val
            this.getEnterpriseList()
        },

        handleCurrentChange(val) {
            this.page = val
            this.getEnterpriseList(val);
        }
    },


}
</script>

<style type="text/css" scoped="scoped"></style>